/**
 * Safe localStorage.getItem for use when storage may be denied (e.g. private browsing).
 * Returns null on error or when key is missing.
 */
export function safeGetItem(key) {
  try {
    return localStorage.getItem(key);
  } catch (_) {
    return null;
  }
}

/**
 * Safe localStorage.setItem. No-op when storage access is denied.
 */
export function safeSetItem(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (_) {
    // Storage access denied
  }
}

/**
 * Safe localStorage.removeItem. No-op when storage access is denied.
 */
export function safeRemoveItem(key) {
  try {
    localStorage.removeItem(key);
  } catch (_) {
    // Storage access denied
  }
}

export function getStorageAndParse(key) {
  const storage = safeGetItem(key);
  if (storage == null) {
    return undefined;
  }

  try {
    return JSON.parse(storage);
  } catch (_) {
    return undefined;
  }
}

export function stringifyAndSetStorage(key, value) {
  try {
    safeSetItem(key, JSON.stringify(value));
  } catch (_) {
    // JSON.stringify failure (unlikely)
  }
}
